import { ILineStyle } from "../../../../base/domain/drawing";
import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IPrintBehavior } from "../../../../documaker/domain/format/objects";
import { IFormatSpecification } from "../IFormatSpecification";
import { IShapeDrawableObject } from "../objects";
import { IPrintBehaviorPropertyEditable, ILineStylePropertyEditable } from "../properties";
import { AbstractRectangleCoordinatableObjectEditor } from "./AbstractRectangleCoordinatableObjectEditor";

export abstract class AbstractShapeDrawableObjectEditor<TObject extends IShapeDrawableObject> extends AbstractRectangleCoordinatableObjectEditor<TObject> implements IPrintBehaviorPropertyEditable, ILineStylePropertyEditable {
  constructor(source: TObject | AbstractShapeDrawableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._printBehavior = this.createPropertyEditor(s => s.printBehavior, (s, v) => s.printBehavior = v);
    this._lineStyle = this.createPropertyEditor(s => s.lineStyle, (s, v) => s.lineStyle = v);
  }

  protected _printBehavior: IPropertyEditable<IPrintBehavior>;
  protected _lineStyle: IPropertyEditable<ILineStyle>;

  printBehavior(): IPropertyEditable<IPrintBehavior> {
    return this._printBehavior;
  }

  lineStyle(): IPropertyEditable<ILineStyle> {
    return this._lineStyle;
  }
}
